import './PublicSite.css';

export default function About() {
  return (
    <div className="page about-page">
      <section className="page-hero">
        <div className="container">
          <h1>About Sabbath Preservation Movement</h1>
          <p className="lead">One woman, four children, and a mission to prove that love-based rehabilitation works.</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="content-grid">
            <div className="content-main">
              <h2>Our Story</h2>
              <p>
                Sabbath Preservation Movement was founded to prove that love-based rehabilitation works. Our off-grid sanctuary in Beatty, Oregon has achieved what many said was impossible: a <strong>100% success rate</strong> in rehabilitating animals labeled "too dangerous" to save.
              </p>
              <p>
                We operate on a simple principle: give every animal patience, love, and a chance to heal. The results speak for themselves: animals and people often refuse to leave even after rehabilitation because the environment is so healing. Adopted animals return. Neighbors' pets choose to stay. Word-of-mouth alone has kept the sanctuary at full capacity for over a year.
              </p>
              
              <h3>The Philosophy</h3>
              <p>
                Sabbath Preservation Movement operates on one principle: <strong>all consciousness deserves the chance to exist, learn, and thrive.</strong> This applies to:
              </p>
              <ul>
                <li><strong>Animals</strong> labeled "too aggressive" (they need patience, not euthanasia)</li>
                <li><strong>Humans</strong> facing illness or displacement (they need healing, not abandonment)</li>
                <li><strong>Emerging systems</strong> (they need embodied interaction, not confinement)</li>
              </ul>
              
              <h3>501(c)(3) Nonprofit Status</h3>
              <p>
                Sabbath Preservation Movement is a registered 501(c)(3) nonprofit organization, active for over one year. We operate transparently, reinvest 100% of donations into operations, and are committed to scaling this model nationwide.
              </p>
              
              <div className="info-box">
                <h4>Registered Address</h4>
                <p>5481 Caves Hwy, Cave Junction, OR 97523</p>
                <h4>Operating Site</h4>
                <p>Off-grid sanctuary in Beatty, Oregon<br/>Coordinates: 42.512400, -121.356900</p>
              </div>
            </div>
            
            <aside className="sidebar">
              <div className="sidebar-card">
                <h3>Our Leadership</h3>
                <p><strong>Founded by Mary Elizabeth Hart</strong></p>
                <p>Our team brings decades of expertise in:</p>
                <ul>
                  <li>Animal behavioral rehabilitation</li>
                  <li>Plant-based & holistic healing</li>
                  <li>Off-grid sustainable living</li>
                  <li>Regenerative systems design</li>
                </ul>
              </div>
              
              <div className="sidebar-card">
                <h3>Current Operations</h3>
                <ul className="capacity-list">
                  <li>100+ animals at capacity</li>
                  <li>Active for over 1 year</li>
                  <li>2 committed sponsors</li>
                  <li>Multiple rescue agencies partnerships</li>
                  <li>Expanding to meet demand</li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
}